<template>
  <div class="flex h-screen w-full items-center justify-center">
    <div class="mx-auto max-w-lg text-center">
      <VLoader width="60px" />
    </div>
  </div>
</template>
